import { toast } from "sonner";
import { Share2, Link2, Instagram, Send, MessageCircle } from "lucide-react";
import { adUrl, adImageUrl, downloadImage } from "@/lib/creatorAds";

const CAPTION = {
  member: "A private dating and adult society… done different. The first 300 members to activate Basic get Premium free for a month. 18+ only.",
  creator: "Now recruiting creators at Velluto. The first 300 approved creators keep 100% of their earnings for 3 months. 18+ only.",
};

const XIcon = () => <span className="font-bold text-[12px] leading-none">𝕏</span>;

const copy = (text, msg) => navigator.clipboard.writeText(text).then(() => toast.success(msg)).catch(() => toast.error("Copy blocked by the browser"));

export function ShareBar({ ad, kind, path, campaign, caption, testPrefix }) {
  const link = (src) => adUrl(path, src, campaign || ad.id, `${kind}-launch`);
  const text = caption || CAPTION[kind];
  const open = (href) => window.open(href, "_blank", "noopener,noreferrer");
  const nativeShare = async () => {
    const url = link("share");
    try {
      const blob = await (await fetch(adImageUrl(ad))).blob();
      const file = new File([blob], ad.file, { type: "image/jpeg" });
      if (navigator.canShare?.({ files: [file] })) return await navigator.share({ files: [file], text: `${text} ${url}` });
      if (navigator.share) return await navigator.share({ title: "Velluto", text, url });
    } catch (e) { if (e?.name === "AbortError") return; }
    copy(`${text} ${url}`, "Caption and link copied");
  };
  const items = [
    { id: "native", label: "Share", Icon: Share2, run: nativeShare },
    { id: "instagram", label: "Instagram", Icon: Instagram, run: () => { downloadImage(ad); copy(`${text} ${link("instagram")}`, "Image saved. Caption and link copied for your Instagram post or bio"); } },
    { id: "x", label: "X", Icon: XIcon, run: () => open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(link("x"))}`) },
    { id: "whatsapp", label: "WhatsApp", Icon: MessageCircle, run: () => open(`https://wa.me/?text=${encodeURIComponent(`${text} ${link("whatsapp")}`)}`) },
    { id: "telegram", label: "Telegram", Icon: Send, run: () => open(`https://t.me/share/url?url=${encodeURIComponent(link("telegram"))}&text=${encodeURIComponent(text)}`) },
    { id: "link", label: "Copy link", Icon: Link2, run: () => copy(link("link"), "Link copied") },
  ];
  return (
    <div data-testid={`${testPrefix}-share`} className="grid grid-cols-2 sm:grid-cols-3 gap-1.5">
      {items.map(({ id, label, Icon, run }) => (
        <button key={id} data-testid={`${testPrefix}-share-${id}`} onClick={run} title={label}
          className={`flex items-center justify-center gap-1.5 py-2 rounded-full text-[10px] uppercase tracking-[0.1em] transition-colors ${id === "native" ? "bg-wine/60 text-text-main hover:bg-wine" : "border border-white/10 text-text-muted hover:text-gold hover:border-gold/60"}`}>
          <Icon size={12} /> {label}
        </button>
      ))}
    </div>
  );
}
